import type {ReactElement} from 'react';
import {InputField} from '@Components/input-field-v2';
import {InputFieldSize, InputFieldState} from '@Components/input-field-v2/input-field.types';
import {useIsCompactQRTool} from '@Components/qr-code-generator/qr-code-generator-hooks';
import {getQRFieldIssueText} from '@Components/qr-code-generator/qr-code-generator.library';
import styles from './qr-field.module.scss';
import type {QRFieldProps} from './qr-field.types';

export function QRField({label, value, field, issues, onValueChange, placeholder, helpText, isMultiline, maxLength, inputType}: QRFieldProps): ReactElement {
  const issueText = field === undefined || issues === undefined ? undefined : getQRFieldIssueText(issues, field);
  const isCompact = useIsCompactQRTool();

  return (
    <div className={styles.qrField}>
      <InputField
        label={label}
        placeholder={placeholder}
        input={value}
        isControlled
        isMultiline={isMultiline}
        maxLength={maxLength}
        inputType={inputType}
        size={isCompact ? InputFieldSize.SMALL : InputFieldSize.MEDIUM}
        state={issueText === undefined ? InputFieldState.DEFAULT : InputFieldState.ERROR}
        information={issueText ?? helpText}
        informationClassName={styles.qrFieldInformation}
        onInputChange={(updatedValue): void => {
          onValueChange(String(updatedValue));
        }}
      />
    </div>
  );
}
